import { render } from "./CustomSelect.vue?vue&type=template&id=11ef2eb0"
import script from "./CustomSelect.vue?vue&type=script&lang=ts"
export * from "./CustomSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script